var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoixLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 77.535,
    height: 24.748,
    viewBox: "0 0 77.535 24.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.151,
    y1: 0.5,
    x2: 0.794,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cffb68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96f889"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75",
    transform: "translate(-163 -23.633)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M19.111.152a2.078,2.078,0,0,1,1.478.584,1.759,1.759,0,0,1,.653,1.409,2.352,2.352,0,0,1-.206.928l-8.49,19.867a2.2,2.2,0,0,1-.894,1.031,2.286,2.286,0,0,1-1.134.309,2.335,2.335,0,0,1-1.066-.344,2.2,2.2,0,0,1-.791-.963L.172,3.039a1.457,1.457,0,0,1-.137-.412A3.173,3.173,0,0,1,0,2.18,1.741,1.741,0,0,1,.722.668,2.3,2.3,0,0,1,2.1.118a1.964,1.964,0,0,1,1.89,1.341l7.528,17.7-1.2.034L17.221,1.458A1.962,1.962,0,0,1,19.111.152Z",
    transform: "translate(163 23.756)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M34.428,12.374a13.29,13.29,0,0,1-.859,4.812,12.305,12.305,0,0,1-2.44,3.953,11.092,11.092,0,0,1-3.712,2.647,11.225,11.225,0,0,1-4.674.963,11.226,11.226,0,0,1-4.675-.963,11.572,11.572,0,0,1-3.712-2.647,12.624,12.624,0,0,1-2.406-3.953,13.29,13.29,0,0,1-.859-4.812,13.29,13.29,0,0,1,.859-4.812,12.208,12.208,0,0,1,2.406-3.918A11.59,11.59,0,0,1,27.416.962a10.872,10.872,0,0,1,3.712,2.681,11.908,11.908,0,0,1,2.44,3.918A13.29,13.29,0,0,1,34.428,12.374Zm-4.468,0a9.17,9.17,0,0,0-.928-4.159,7.565,7.565,0,0,0-2.544-2.99,6.5,6.5,0,0,0-3.747-1.1,6.5,6.5,0,0,0-3.747,1.1,7.621,7.621,0,0,0-2.544,2.956,9.545,9.545,0,0,0-.894,4.193,9.688,9.688,0,0,0,.894,4.193,7.622,7.622,0,0,0,2.544,2.956,6.5,6.5,0,0,0,3.747,1.1,6.5,6.5,0,0,0,3.747-1.1,7.621,7.621,0,0,0,2.544-2.956A9.387,9.387,0,0,0,29.959,12.374Z",
    transform: "translate(174.591 23.633)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M28.877,22.2a2,2,0,0,1-.653,1.512,2.2,2.2,0,0,1-1.512.584,2.09,2.09,0,0,1-1.547-.584A2.12,2.12,0,0,1,24.58,22.2V2.333A1.946,1.946,0,0,1,25.2.855,2.141,2.141,0,0,1,26.78.236a1.979,1.979,0,0,1,1.444.619,1.9,1.9,0,0,1,.653,1.478Z",
    transform: "translate(188.693 23.88)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M45.91.182A1.727,1.727,0,0,1,47.25.8a1.887,1.887,0,0,1,.584,1.306,2,2,0,0,1-.447,1.237l-6.909,9.109-2.337-3.2,6.084-8.078A2.066,2.066,0,0,1,45.91.182ZM30.58.113a2.059,2.059,0,0,1,1.684.894L47.388,21.115a2.061,2.061,0,0,1,.413,1.272,1.831,1.831,0,0,1-.687,1.512,2.2,2.2,0,0,1-1.375.55,2.059,2.059,0,0,1-1.684-.894L28.93,3.448a1.911,1.911,0,0,1-.447-1.237A1.9,1.9,0,0,1,29.136.732,2.139,2.139,0,0,1,30.58.113ZM30.27,24.449a1.784,1.784,0,0,1-1.306-.55,1.824,1.824,0,0,1-.55-1.272,2.229,2.229,0,0,1,.516-1.409l6.977-9.452L38.176,15.1l-6.187,8.387A2.048,2.048,0,0,1,30.27,24.449Z",
    transform: "translate(192.701 23.752)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M21.465,7.066a.614.614,0,0,1,0,1.092L16.519,10.7a.614.614,0,0,1-.894-.546V5.073a.614.614,0,0,1,.894-.546Z",
    transform: "translate(179.333 28.294)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoixLogo);
export default __webpack_public_path__ + "static/media/voixLogo.1f6083982718411d1fe36f8da38c8a2e.svg";
export { ForwardRef as ReactComponent };